<template>
    <div class="o-column c-admin_signin">
        <img class="c-admin_signin_logo" :src="linkk + '/pharaohfrog.png'" alt="logo">
        <form method="POST" class="column">
            <input type="text" placeholder="Username" name="name" v-model="name">
            <input type="password" placeholder="Password" name="password" v-model="password">
            <button @click.prevent="login_front()" class="column flex_center btnn">
                <spinner v-if="loading"></spinner>
                <div v-else>Login</div>
            </button>
            <div v-if="error" class="err_single_line">{{ error }}</div>
        </form>

        <!-- <div class="choose_cashier_cont" v-if="choose_cashier_pop_up">
            <div class="choose_cashier_pop_up">
                <h2>Choose Cashier</h2>

                <div class="row cashier_list" v-if="cashiers && cashiers.length > 0">

                    <div  :class="cashier.selected ? 'cashier_item cashier_item_selected' : 'cashier_item'" v-for="cashier in cashiers" :key="cashier.id" @click="select_cashier(cashier)">
                        <img :src="linkk + '/' + cashier.profile_pic" alt="cashier image">
                        <div class="cashier_name">{{ cashier.name }}</div>
                    </div>
                </div>
                <button class="save_cashier_btn" @click="save_selected_cashier()">Let's Go</button>
            </div>
        </div> -->

      <!-- <ChooseCashierPopUp :visible="showChooseCashier" @close="showChooseCashier = false" /> -->

      

        
    </div>
</template>

<script>
// @ is an alias to /src
import Spinner from '@/components/Spinner.vue';
import { mapState, mapActions } from 'vuex';
import request from '../axios_request';
// import ChooseCashierPopUp from "@/components/ChooseCashierPopUp.vue";
// import io from "socket.io-client";

export default {
    name: 'Login_',
    components: {
        Spinner,
        // ChooseCashierPopUp
    },
    data: function () {
        return {
            name: null,
            password: null,
            loading: false,
            error: null,
            balck: false,

            // choose_cashier_pop_up: false,

            cashiers: [],
            linkk: process.env.VUE_APP_SERVER_ENDPOINT,
            showChooseCashier: false
        };
    },
    methods: {
        ...mapActions([
            "set_logged_in",
            "set_socket",
            "role_",
            'admin_name_',
            'company_logo_',
            'company_'
        ]),
        login_front(){
            if( this.loading ){
                return;
            }

            this.loading = true;
            this.error = false;

            if( !this.name || this.name.length <= 0 ){
                this.error = 'must enter name.';
                this.loading = false;
                return;
            }

            if( !this.password || this.password.length <= 0 ){
                this.error = 'must enter password.';
                this.loading = false;
                return;
            }

            if( this.password && this.password.length < 5 ){
                this.error = 'password must be more then 5 letters.';
                this.loading = false;
                return;
            }


            var data = {
                name: this.name,
                password: this.password
            }

            request.post('/api/system/login', data)
                .then((response)=>{
                    if( response.status === 200 ){
                        localStorage.setItem('token', response.data.token);
                        console.log(this.role);
                        this.set_logged_in(true);
                        this.role_(response.data.role);
                        this.admin_name_(response.data.name);
                        this.company_logo_(response.data.img);
                        this.company_(response.data.company);
                        // this is make u dont refreash when u logout and back in
                        request.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;


                        if( this.role === 'customer' ){
                            this.$router.push({name: 'home'});
                        }else{

                            if( this.role ){
                                this.$router.push({name: 'admin'});
                            }
                            
                        }
                        

                        // this.set_socket(io.connect("http://localhost:3000",
                        // {
                        //     auth: {
                        //     token: response.data.token,
                        //     },
                        // }
                        // ));
                    }else{
                        this.error = 'error 1';
                    }
                    this.loading = false;
                }).catch(e => {
                    console.log(e);
                    this.loading = false;
                    this.error = 'error 2';
                });
        },
        close_choose_cashier(){
            this.choose_cashier_pop_up = false;
        },
        // select cashier from pop up and only can select one cashier and change cashier card color to green when selected
        select_cashier(cashier){
            if(cashier.selected && cashier.selected === true){
                cashier.selected = false;
                return;
            }
            cashier.selected = true;
            //loop through cashiers and unselect all other cashiers
            this.cashiers.forEach(c => {
                if( c.id !== cashier.id ){
                    c.selected = false;
                }
            });
            // change the selected cashier card color to green
            // this.choose_cashier_pop_up = false;
            // this.$router.push({name: 'admin'});
        },
        // save selected cashier in local storage and check its only on cashier selected go to admin page
        save_selected_cashier(){
            let selected_cashier = this.cashiers.find(cashier => cashier.selected === true);
            if( !selected_cashier ){
                alert('Please select a cashier to proceed.');
                return;
            }
            localStorage.setItem('cashier_id', selected_cashier.id);
            this.choose_cashier_pop_up = false;
            this.$router.push({name: 'admin'});
        } 
    },
    computed: {
        ...mapState([
            'role',
            // 'logged_in',
            // 'branch_id',
            // 'socket'
        ]),
    }
}
</script>

<style scoped>
/* .login_cont{
    display: flex;
    justify-content: center;
    margin-top: 5%;
}

.login_cont img{
    width: 100%;
    max-width: 250px;
    margin: auto;
    display: flex;
    margin-bottom: 10px;
} */


.c-admin_signin{
    width: 100%;
    max-width: 350px;
    padding: 0px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.c-admin_signin img{
    height: 170px;
    margin-bottom: 10px;
}

.c-admin_signin_logo{
    margin-bottom: 10px;
}

form{
    width: 100%;
}

input{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 18px;
    transition: 0.1s;
    outline: none;
    padding: 10px 13px;
    margin-bottom: 10px;
}

button{
    background-color: #317BEB;
    border: 0px;
    padding: 7px 0px;
    color: #F2F2F2;
    font-size: 18px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: 500;
    border-radius: 3px;
    cursor: pointer;
    text-align: center;
}

input:focus {
    border: 1px solid #317BEB;
    /* border-right: 0px; */
}

.btnn{
    align-items: center;
    width: 100%;
}


.err_single_line{
    color:red;
    font-size: 17px;
}

.choose_cashier_cont{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.choose_cashier_pop_up{
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* make .cashier_item image circle and but cashier name under it and make it responsive */
.cashier_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 10px;

    background-color: #cccccc5e;
    border-radius: 5px;
    padding: 15px;
    border: 2px solid #ccc;

}
.cashier_item img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 5px;
}
.cashier_name{
    font-size: 16px;
    font-weight: 500;
}

/* change it cool shade of blue */
.cashier_item_selected{
    border: 2px solid #317BEB;
    background-color: #d0e4ff;
}

.save_cashier_btn{
    padding: 10px 25px;
    margin-top: 15px;
}

</style>